import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class ProgressBar extends Component {
  state = {
    value: 0,
  }

  componentDidMount = () => {
    const { end, start } = this.props;
    // Initial value
    this.setState({ value: `${start}%` });

    setTimeout(() => {
      this.setState({ value: `${end}%` });
    }, 500);
  }

  render() {
    const {
      after, before, category, end, start,
    } = this.props;
    const { value } = this.state;

    return (
      <div className="progress">
        <div className="progress__current">{before}</div>
        <div className="progress__bar">
          <div
            className={classnames(
              'progress-bar progress-bar--light-background',
              category === 'Menace' && 'progress-bar--menace',
            )}
          >
            <span
              className={classnames(
                'progress-bar__stripe',
                start !== end && 'progress-bar__stripe--has-transition',
                category === 'Menace' && 'progress-bar__stripe--menace',
              )}
              style={{ width: value }}
            />
          </div>
        </div>
        <div className="progress__current">{after}</div>
      </div>
    );
  }
}

ProgressBar.propTypes = {
  after: PropTypes.number.isRequired,
  before: PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
  end: PropTypes.number.isRequired,
  start: PropTypes.number.isRequired,
};
